const letterList = 'htps:/.-abcdefgijklmnopqruvwxyz0123456789?=';
const hostMap = {
    mexSaTestHost: [
        0, 1, 1, 2, 3, 4, 5, 5, 11, 8, 1, 8, 3, 15, 20, 17, 7, 19, 12, 28, 6, 13, 15, 20, 1, 21, 2, 15, 8, 6, 1, 12, 10,
        0, 5, 3, 8, 41, 2, 24, 21, 16, 12, 10, 1, 42, 11, 12, 13, 8, 25, 18, 1
    ],
    cnSaProdHost: [
        0, 1, 1, 2, 3, 4, 5, 5, 11, 8, 1, 8, 3, 15, 20, 17, 6, 13, 15, 20, 1, 21, 2, 15, 8, 6, 1, 12, 10, 0, 5, 3, 8,
        41, 2, 24, 21, 16, 12, 10, 1, 42, 2, 24, 21, 11, 25, 10, 1, 15, 21, 20
    ],
    cnSaTestHost: [
        0, 1, 1, 2, 3, 4, 5, 5, 11, 8, 1, 8, 3, 15, 20, 17, 6, 13, 15, 20, 1, 21, 2, 15, 8, 6, 1, 12, 10, 0, 5, 3, 8,
        41, 2, 24, 21, 16, 12, 10, 1, 42, 11, 12, 13, 8, 25, 18, 1
    ],
    ecH5TestHost: [
        0, 1, 1, 2, 3, 4, 5, 5, 1, 12, 3, 1, 7, 15, 20, 11, 21, 7, 12, 8, 3, 29, 10, 8, 3, 0, 7, 0, 36, 6, 13, 15, 20,
        1, 21, 2, 15, 8, 6, 1, 12, 10, 0
    ],
    ecTestHost: [
        0, 1, 1, 2, 3, 4, 5, 5, 1, 12, 3, 1, 7, 15, 20, 11, 21, 7, 12, 8, 3, 29, 10, 8, 3, 0, 6, 13, 15, 20, 1, 21, 2,
        15, 8, 6, 1, 12, 10, 0
    ]
};
export const getHost = (type) => {
    return hostMap[type]?.map?.(i => letterList[i]).join('') || '';
};
